import React from 'react';
import type { ChatStep } from '../../../../types/stream.types';
import type { ToolRenderer, ToolSummary, ToolContent } from '../tool-renderer.types';

export class DefaultToolRenderer implements ToolRenderer {
  getSummary(step: ChatStep, isStreaming: boolean): ToolSummary {
    const description = step.input?.arguments?.description;
    if (description && typeof description === 'string' && description.trim()) {
      return { text: description.trim() };
    }

    const hasOutput = step.output !== undefined;
    const content = step.output?.content || '';

    if (hasOutput && content) {
      const preview = String(content).substring(0, 40).trim();
      return {
        text: preview ? `${preview}...` : 'Completed',
      };
    }

    return {
      text: isStreaming ? 'Processing...' : 'In progress',
    };
  }

  getContent(step: ChatStep): ToolContent {
    const content = step.output?.content || '';

    return {
      main: (
        <div className="text-xs text-gray-500 leading-relaxed whitespace-pre-wrap">
          {content || 'No content'}
        </div>
      ),
    };
  }
}
